import axios from 'axios';
import {downloadPostFile} from "../../../utils/file/download";
import {withoutComma} from "../../../utils/calculate/Amount"
import {ADDRESS_BY_ACCOUNT} from "../../../utils/constants/Constants";

export class InvoiceService {
    getInvoice(filters) {
        return axios.get('/appapv/getInvoice.action', {
            params: {
                fechaInicial: filters.startDate.getFullYear() + "-" +
                    (filters.startDate.getMonth() + 1) + "-01",
                fechaFinal: filters.finalDate.getFullYear() + "-" +
                    (filters.finalDate.getMonth() + 1) + "-" +
                    new Date(filters.finalDate.getFullYear(),
                        filters.finalDate.getMonth() + 1, 0).getDate(),
                idInstitucion: filters.catInstitutionLenderFilter.idInstitucion ?
                    filters.catInstitutionLenderFilter.idInstitucion : "0",
            }
        }).then(res => res.data);
    }

    getPercent() {
        return axios.get('/appapv/getPercent.action', {
            params: {}
        }).then(res => res.data);
    }

    getInstitutionInvoice() {
        return axios.get('/appapv/getInstitutionInvoice.action', {
            params: {}
        }).then(res => res.data);
    }

    getInvoiceXLS(selectedInvoice, startDate, finalDate) {
        let invoiceList = [];
        let fechaInicialAux = startDate.getFullYear() + "-" + (startDate.getMonth() + 1) + "-01";
        let fechaFinalAux = finalDate.getFullYear() + "-" + (finalDate.getMonth() + 1) + "-" +
            new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate();

        selectedInvoice.forEach(item => {
            invoiceList.push({
                idInstitucion: item.idInstitucion,
                nomCliente: item.institucion,
                operaciones: item.listaDetalle.length,
                importe: item.importe,
                iva: item.iva,
                total: item.total,
                fechaInicial: fechaInicialAux,
                fechaFinal: fechaFinalAux,
                cuenta: item.cuenta ? item.cuenta : "",
            });
        });
        let params = {listaFactura: JSON.stringify(invoiceList)};
        return downloadPostFile('/appapv/getInvoiceXls.action', params);
    }

    updatePercent(percentPtm, percentPtt) {
        let params = [
            {
                rol: percentPtm.rol,
                porcentaje: withoutComma(percentPtm.porcentaje) / 100,
            }, {
                rol: percentPtt.rol,
                porcentaje: withoutComma(percentPtt.porcentaje) / 100,
            }
        ];
        return axios.post('/appapv/updatePercent.action', {}, {
            params: {listPercentageJson: JSON.stringify(params)}
        }).then(res => res.data);
    }

    getAddressesInstitution(idInstitution) {
        return axios.get('/appapv/getAddressesInstitution.action', {
            params: {
                idInstitucion: idInstitution,
            }
        }).then(res => res.data);
    }

    getInstitutionAccounts(idInstitution) {
        return axios.get('/appapv/getAccountsInstitution.action', {
            params: {
                idInstitucion: idInstitution,
            }
        }).then(res => res.data);
    }

    updateInstitutionAddress(institutionData, addressDataList, sameAddress) {
        let invoiceList = [];
        addressDataList.forEach((addressData) =>
            invoiceList.push({
                idInstitucion: institutionData.IdInstitucion,
                rfc: addressData.RFC,
                direccion: addressData.Dir,
                colonia: addressData.Colonia,
                cp: addressData.CP,
                ciudad: addressData.Cd,
                razonSocial: institutionData.RazonSocial,
                nomCliente: institutionData.NomCorto,
                cuenta: institutionData.IdTipo === ADDRESS_BY_ACCOUNT ? addressData.Cuenta : '',
            })
        );
        return axios.post('/appapv/updateDirectionsInstitution.action', {}, {
            params: {
                invoiceListJson: JSON.stringify(invoiceList),
                isSameDirection: sameAddress,
                idTipoFactura: institutionData.IdTipo,
            }
        }).then(res => res.data);
    }
}